const typographyMyComp = {
  company: 'Mi empresa',
  profileError: 'Espere a que se cargue el archivo',
  user: 'Número de Usuarios:',
  userValue: '6 (60%)',
  plan: 'consumo de datos:',
  planValue: '32,5 GB (73%)',
  contract: 'Plan Contratado:',
  contractValue: '10 users/50 GB',
  formLabelTitle: 'Contratación del plan:',
  formLabelValue: '10/08/2019 às 08:23 (3 meses)'
};

export default typographyMyComp;
